import styled from 'styled-components';
import {
  color,
  fontSize,
  fontWeight,
  width,
  opacity,
  height,
  border,
  padding,
  margin,
} from 'styled-system';

const BaseTextInput = styled.input`
  ${width};
  ${border};
  ${color};
  ${opacity};
  ${height};
  ${fontSize};
  ${fontWeight};
  ${padding};
  ${margin};
`;

export default BaseTextInput;
